import React, {
  ReactNode,
  forwardRef,
  ForwardedRef,
  ReactElement
} from 'react';
import cn from 'classnames';

export interface Props {
  name?: string;
  type?: 'email' | 'number' | 'password' | 'search' | 'tel' | 'text';
  titleClassName?: string;
  inputWrapperClassName?: string;
  inputClassName?: string;
  title?: string | ReactElement;
  isRequired?: boolean;
  isWrong?: boolean;
  isWarning?: boolean;
  placeholder?: string;
  leftPlaceComponent?: ReactNode | HTMLElement | string;
  rightPlaceComponent?: ReactNode | HTMLElement | string;
  inputId?: string;
  disabled?: boolean;
  roundStyle?: string;
  autoCompleteNeeded?: boolean;
  // TODO: replace any type with the actual type!
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

const Input = forwardRef(
  (props: Props, ref: ForwardedRef<HTMLInputElement> = null) => {
    const {
      name = '',
      type = 'text',
      titleClassName = '',
      inputWrapperClassName = '',
      inputClassName = '',
      title = '',
      isRequired = false,
      isWrong = false,
      isWarning = false,
      placeholder = '',
      leftPlaceComponent = null,
      rightPlaceComponent = null,
      inputId,
      disabled,
      roundStyle = 'rounded-lg',
      autoCompleteNeeded = true,
      ...inputProps
    } = props;

    return (
      <>
        {title && (
          <div
            className={cn(
              'pl-1.5 mb-2 text-shuttleGray',
              isRequired && 'compendium-required-input-style',
              titleClassName
            )}
          >
            {title}
          </div>
        )}
        <div
          className={cn(
            'border border-solid border-alto rounded-lg flex flex-row items-center bg-white',
            inputWrapperClassName,
            isWrong && '!border-scarlet',
            isWarning && '!border-pizazz',
            disabled && '!border-mercury !bg-wildSand'
          )}
        >
          <>{leftPlaceComponent}</>
          {disabled ? (
            <div className="px-4 h-full w-full fs-body-reg text-black items-center flex">
              <p>{inputProps?.value || ''}</p>
            </div>
          ) : (
            <input
              id={inputId}
              autoComplete={autoCompleteNeeded ? 'on' : 'off'}
              ref={ref}
              name={name}
              type={type}
              className={cn(
                'p-2.5 h-full w-full bg-white fs-body-reg text-black placeholder:text-black placeholder:opacity-90 text-ellipsis focus:outline-none',
                roundStyle,
                inputClassName
              )}
              placeholder={placeholder}
              {...inputProps}
            />
          )}
          <>{rightPlaceComponent}</>
        </div>
      </>
    );
  }
);

Input.displayName = 'Input';

export default Input;
